<template>
  <div
    class="benefit-list tw:px-4 tw:pt-6"
    :class="hasTopBarBannerLayout && 'has-top-banner'"
  >
    <div class="event-box">
      <div
        v-for="section in eventSections"
        :key="section.id"
        class="tw:mb-6!"
      >
        <h2 class="section-name tw:mb-3!">
          {{ section.name }}
        </h2>
        <div class="tw:flex tw:flex-col tw:gap-2">
          <EventItem
            v-for="item in section.items"
            :key="item.eventId"
            :event="item"
            @click-event-item="handleClickEvent(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { hasTopBarBannerLayout } = storeToRefs(useLayout())

defineProps<{
  eventSections: EventSection[]
  eventBanners: EventBanner[]
}>()

const emits = defineEmits(['click-event-item'])
const gtm = useGtm()

const handleClickEvent = (item: EventItem) => {
  gtm?.trackEvent({
    event: 'click_benefit_list',
    event_id: item.eventId,
    event_name: item.title
  })
  emits('click-event-item', item)
}
</script>

<style lang="scss" scoped>
.benefit-list {
  background-color: $base-white;
  &.has-top-banner {
    top: calc(56px + $top-banner-height);
    :deep(.el-tabs__header) {
      top: calc(56px + $top-banner-height);
    }
  }
  .section-name {
    @include body3-semibold;
    color: $base-black;
  }
  .event-box {
    padding-bottom: 145px;
  }
}
</style>
